export default "__VITE_PUBLIC_ASSET__7186c84c__"